import { useEffect, useState } from 'react';
import type { AgoraPublicationLike } from '../../types';
import type { ILocalTrack, IRemoteAudioTrack, IRemoteVideoTrack } from 'agora-rtc-sdk-ng';

export default function useTrack(
  publication: AgoraPublicationLike | undefined
): ILocalTrack | IRemoteAudioTrack | IRemoteVideoTrack | null {
  const [track, setTrack] = useState(publication?.track ?? null);

  useEffect(() => {
    setTrack(publication?.track ?? null);
  }, [publication?.track, publication?.trackName, publication?.kind]);

  return track;
}
